import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { foundItems } from "../../../features/LostFound/dummy/fountItems";

// Initial state
const initialState = {
  loading: null,
  loaded: null,
  error: null,
  data: null,
  receiptNumber: null,
  status: null,
};

// Slice
const registerLostItemSlice = createSlice({
  name: "registerLostItem",
  initialState,
  reducers: {
    submitData(state) {
      return { ...state, loading: true, error: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setStatus(state, action) {
      const { receiptNumber } = action.payload;
      return {
        ...state,
        status: true,
        receiptNumber,
      };
    },
    initState(state) {
      return {
        ...state,
        loading: null,
        loaded: null,
        error: null,
        data: null,
        receiptNumber: null,
        status: null,
      };
    },
  },
});

export const {
  submitData,
  fetchDataSuccess,
  fetchDataFailure,
  setStatus,
  initState,
} = registerLostItemSlice.actions;

export default registerLostItemSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.post, apiUrl, data);
    if (response?.data) {
      const { result_code, result_data } = response.data;
      if (result_code === "20000") {
        const { acpn_number } = result_data[0];
        yield put(setStatus({ receiptNumber: acpn_number }));
      }
    }
    yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* registerLostItemSaga() {
  yield takeLatest(submitData.type, fetchDataSaga);
}
